import React from "react";
import "./NotFound.css";
import useSize from "../useSize/useSize";

export default function NotFound({
  small,
  height,
  title = "No Data Found",
  subtext = "We couldn’t find anything to show here.",
}) {
  const windowSize = useSize();

  return (
    <div
      className="loadingContainer"
      style={{
        height: height ? height : windowSize[1] - 70,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className={`titleNodata ${small ? "extralarge" : null} `}>
        {title}
      </div>
      <div className={`Nodata ${small ? "large" : null} `}>{subtext}</div>
    </div>
  );
}
